import API from "@/lib/API";

export const appointmentService = {
  getAppointments: async (params = {}) => {
    return await API.get('/verve-leads', { params });
  },

  updateAppointment: async (id, data) => {
    return await API.patch(`/verve-leads/${id}`, data);
  },

  removeAppointment: async (id) => {
    // This action moves the lead back to the 'new' stage and clears appointment details
    return await API.patch(`/verve-leads/${id}`, {
      appointmentDate: null,
      appointmentNote: "",
      status: "new",
      activityNote: "Appointment cancelled and removed from scheduled list."
    });
  },

  getTeams: async () => {
    return await API.get('/teams?limit=1000');
  }
};
